import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class FirBasketMaintenanceService {
  constructor(private http: HttpClient) {}

  private postLoad(baseUrl: string, actionCode: string, taxYear: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const body = new URLSearchParams();
    body.set('action_code', actionCode);
    body.set('tax_year', String(taxYear ?? ''));
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }

  getSourceCodes(baseUrl: string, taxYear: any): Observable<any> {
    return this.postLoad(baseUrl, '7lsdkp', taxYear);
  }
  getFtcCodes(baseUrl: string, taxYear: any): Observable<any> {
    return this.postLoad(baseUrl, '8a85he', taxYear);
  }
  getPassiveCodes(baseUrl: string, taxYear: any): Observable<any> {
    return this.postLoad(baseUrl, 'qhxqzz', taxYear);
  }
  getSubfCodes(baseUrl: string, taxYear: any): Observable<any> {
    return this.postLoad(baseUrl, '396a36', taxYear);
  }
  getFphciCodes(baseUrl: string, taxYear: any): Observable<any> {
    return this.postLoad(baseUrl, 'h43mo3', taxYear);
  }
  get902Name(baseUrl: string, taxYear: any): Observable<any> {
    return this.postLoad(baseUrl, 'oly2ic', taxYear);
  }

  saveBasket(
    baseUrl: string,
    basketData: any,
    globalParams: any = {},
    filterParams: any = {},
    ssoId: string = ''
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=owfq9a`;
    let params: any = _.merge({}, globalParams || {}, filterParams || {});
    params = _.extend({ jsonObj: JSON.stringify(basketData) }, params);
    params = _.extend({ jsonSettings: JSON.stringify([{ sso_id: ssoId, screen_key: globalParams?.screen_key || '' }]) }, params);
    params.sso_id = ssoId || '';

    const body = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null) {
        body.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
}
